import { PaletteOptions } from "@mui/material/styles";

import {
  darkGrey,
  darkBlue,
  lightBlue,
  white,
  error,
  warning,
  success,
  info,
} from "./colors";

// Configuration for the palette
const pallette: PaletteOptions = {
  primary: {
    main: darkBlue,
    light: lightBlue,
  },
  secondary: {
    main: white,
  },
  warning: {
    main: warning,
  },
  info: {
    main: info,
  },
  success: {
    main: success,
  },
  error: {
    main: error,
  },
  text: {
    primary: darkGrey,
  },
};

export default pallette;
